// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/prepaid-expenses',
        component: () =>
            import('@/pages/[organisation]/accounting/prepaid-expenses.vue'),
        name: 'accounting.prepaid-expenses.search-prepaid-expenses',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.prepaid-expense.view-prepaid-expenses',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/accounting/prepaid-expenses/new.vue'),
                name: 'accounting.prepaid-expenses.create-prepaid-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.prepaid-expense.create-prepaid-expense',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/prepaid-expenses/[id].vue'),
                name: 'accounting.prepaid-expenses.view-prepaid-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.prepaid-expense.view-prepaid-expenses',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/accounting/prepaid-expenses/[id]/edit.vue'),
                name: 'accounting.prepaid-expenses.update-prepaid-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.prepaid-expense.update-prepaid-expense',
                },
            },
        ],
    },
];
